// src/services/bolService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const bolService = {
  // ── BOL Settings ──────────────────────────────────────────────────────────
  getSettings: () =>
    axios.get(`${API_URL}/api/bol/settings`, authHeader()).then(r => r.data),

  updateSettings: (data) =>
    axios.patch(`${API_URL}/api/bol/settings`, data, authHeader()).then(r => r.data),

  // ── Lot Code Suggestions ──────────────────────────────────────────────────
  getLotCodeSuggestions: (productId) =>
    axios.get(`${API_URL}/api/bol/lot-code-suggestions`, { ...authHeader(), params: productId ? { productId } : {} })
      .then(r => r.data.lotCodes || []),

  // ── BOL Number ────────────────────────────────────────────────────────────
  getNextBolNumber: () =>
    axios.get(`${API_URL}/api/bol/next-bol-number`, authHeader()).then(r => r.data),

  // ── Lot Code Availability ─────────────────────────────────────────────────
  getLotCodeAvailability: (lotCode, productId) =>
    axios.get(`${API_URL}/api/bol/lot-code-availability/${encodeURIComponent(lotCode)}`, {
      ...authHeader(),
      params: productId ? { productId } : {},
    }).then(r => r.data),

  // ── CRUD ──────────────────────────────────────────────────────────────────
  getBols: (params = {}) =>
    axios.get(`${API_URL}/api/bol`, { ...authHeader(), params }).then(r => r.data),

  getBol: (id) =>
    axios.get(`${API_URL}/api/bol/${id}`, authHeader()).then(r => r.data),

  createBol: (data) =>
    axios.post(`${API_URL}/api/bol`, data, authHeader()).then(r => r.data),

  updateBol: (id, data) =>
    axios.patch(`${API_URL}/api/bol/${id}`, data, authHeader()).then(r => r.data),

  deleteBol: (id) =>
    axios.delete(`${API_URL}/api/bol/${id}`, authHeader()).then(r => r.data),

  // ── Status transitions ────────────────────────────────────────────────────
  finalizeBol: (id) =>
    axios.post(`${API_URL}/api/bol/${id}/finalize`, {}, authHeader()).then(r => r.data),

  unfinalizeBol: (id) =>
    axios.post(`${API_URL}/api/bol/${id}/unfinalize`, {}, authHeader()).then(r => r.data),

  // ── Signed scan upload ────────────────────────────────────────────────────
  getSignedUploadUrl: (id, fileName, contentType) =>
    axios.post(`${API_URL}/api/bol/${id}/upload-signed`, { fileName, contentType }, authHeader()).then(r => r.data),

  confirmSignedUpload: (id, publicUrl) =>
    axios.patch(`${API_URL}/api/bol/${id}/confirm-signed`, { publicUrl }, authHeader()).then(r => r.data),
};

export default bolService;
